import { QualityWidgetType } from '../models/';
import { QualityBadActorsWidget } from './badActors/qualityBadActors/qualityBadActors.widget';

export function createQualityBadActorsWidget(type: string, config?: any): QualityBadActorsWidget {
    let localConfig: {
        name: string,
        qualityWidgetType: QualityWidgetType
    };
    switch (type) {
        case 'badActors':
            localConfig = {
                name: 'Bad tags - Most frequent issues',
                qualityWidgetType: QualityWidgetType.BadValuesMostFrequent
            };
            break;
        case 'badActorsByConnectionPointMissing':
            localConfig = {
                name: 'Missing by connection point - Most frequent issues',
                qualityWidgetType: QualityWidgetType.MissingTagsPerConnectionPoint
            };
            break;
        case 'badActorsFlat':
            localConfig = {
                name: 'Flat tags - Most frequent issues',
                qualityWidgetType: QualityWidgetType.FlatTags
            };
            break;
        case 'badActorsInvalidKpis':
            localConfig = {
                name: 'Bad actors invalid KPIs',
                qualityWidgetType: QualityWidgetType.InvalidKPI
            };
            break;
        case 'badActorsMissing':
            localConfig = {
                name: 'Missing values - Most frequent issues',
                qualityWidgetType: QualityWidgetType.MissingTags
            };
            break;
        case 'badActorsOutOfRange':
            localConfig = {
                name: 'Out-of-range tags - Most frequent issues',
                qualityWidgetType: QualityWidgetType.OutOfRangeTags
            };
            break;
        case 'badActorsScatter':
            localConfig = {
                name: 'Scattered tags - Most frequent issues',
                qualityWidgetType: QualityWidgetType.ScatteredTags
            };
            break;
        case 'badActorsSuspiciousKpis':
            localConfig = {
                name: 'Suspicious KPIs - Most frequent issues',
                qualityWidgetType: QualityWidgetType.SuspiciousKPI
            };
            break;
        case 'errorsDistribution':
            localConfig = {
                name: 'Errors distribution',
                qualityWidgetType: QualityWidgetType.PercentageOfBadValuesByType
            };
            break;
        case 'qualityBadActors':
            localConfig = {
                name: config?.name,
                qualityWidgetType: config?.qualityWidgetType
            };
            break;
    }
    const widget = !!localConfig
        ? new QualityBadActorsWidget((Object as any).assign({}, localConfig, config)) // order of copy is important to override defualt parameters
        : null;
    return widget;
}